/** Production PDF service — separate from the main app API. */
export const PDF_API_BASE =
  "https://production-pdf-service-510880133590.europe-west1.run.app";
